import { render, staticRenderFns } from "./author-list-search.vue?vue&type=template&id=e3bf4084&"
import script from "./author-list-search.vue?vue&type=script&lang=js&"
export * from "./author-list-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports